export default "__VITE_ASSET__BCRqWjq5__"